import { render, staticRenderFns } from "./StreetSubCitySelector.vue?vue&type=template&id=40b4d65e"
import script from "./StreetSubCitySelector.vue?vue&type=script&lang=ts"
export * from "./StreetSubCitySelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports